module.exports = __webpack_public_path__ + "static/media/elephant_offer.115428a8.svg";